import { takeLatest, put, call, take } from "redux-saga/effects";
import {  
    EMAILRULE_TICKET_GET_DATA, EMAILRULE_TICKET_DATA_GET_API,  
    EMAIL_RULE_GET_DETAILS_DATA, EMAILRULE_GET_DETAIL_API,
    EMAILRULE_FORM_ADD_DATA, EMAILRULE_FORM_POST_API,
    EMAILRULE_UPDATE_DATA, EMAILRULE_POST_API,
    EMAILRULE_DELETE_DATA, EMAILRULE_DELETE_API,
} from './Constants'
import {
    setEmailRuleTicketDataFail, setEmailRuleTicketDataSuccess,
    setEmailRuleGetDataFail, setEmailRuleGetDataSuccess,
    setEmailRuleFormAddDataFail, setEmailRuleFormAddDataSuccess, 
    setEmailRuleUpdateDataFail, setEmailRuleUpdateDataSuccess,  
    setEmailRuleDeleteDataFail, setEmailRuleDeleteDataSuccess,    
} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";

function* getEmailRuleTicketDataService() {
  try {
    const getEmailRuleTicketDataResponse = yield call(ticketApi.get, EMAILRULE_TICKET_DATA_GET_API);
    const status = getEmailRuleTicketDataResponse.status;
    if (status === 200) {
      const data = getEmailRuleTicketDataResponse.data.data;
      yield put(setEmailRuleTicketDataSuccess(data));
    } else {
      yield put(setEmailRuleTicketDataFail(getEmailRuleTicketDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setEmailRuleTicketDataFail(error));
  }
}

function* getEmailRuleGetDataService({ id }) {
  try {
    const getEmailRuleGetDataResponse = yield call(
      ticketApi.getDetail,
      EMAILRULE_GET_DETAIL_API + id
    );
    const status = getEmailRuleGetDataResponse.status;
    if (status === 200) {
      const newData = getEmailRuleGetDataResponse.data.data;
      yield put(setEmailRuleGetDataSuccess(newData));
    } else {
      yield put(setEmailRuleGetDataFail(getEmailRuleGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setEmailRuleGetDataFail(error));
  }
}

function* postMyEmailRuleFormDataService({ request }) {
  try {
    const response = yield call(
      ticketApi.post,
      EMAILRULE_FORM_POST_API,
      request
    );

    const status = response?.status;
    const apiData = response?.data || response;

    // SUCCESS → if API returns 200 or 201
    if (status === 200 || status === 201 || apiData?.success) {
      yield put(addSuccessAlert(apiData.msg || "EmailRule Created"));
      yield put(setEmailRuleFormAddDataSuccess(apiData.data));
      return;
    }

    // FAIL CASE (API returned non-success status)
    yield put(addErrorAlert(apiData.msg || "Error adding EmailRule"));
    yield put(setEmailRuleFormAddDataFail(apiData.msg));
  } catch (error) {
    // SERVER/NETWORK ERROR
    const msg =
      error?.response?.data?.msg ||
      error?.message ||
      "Error adding EmailRule";

    yield put(addErrorAlert(msg));
    yield put(setEmailRuleFormAddDataFail(msg));
  }
}

function* postEmailRuleDataService({ request }) {
    try {
        const response = yield call(ticketApi.put, EMAILRULE_POST_API + request.id, request);
        if (response.status === 200) {
            yield put(addSuccessAlert("EmailRule updated"))
            yield put(setEmailRuleUpdateDataSuccess(response.data.data));
        } else {
            yield put(addErrorAlert(response.response.data.msg))
            yield put(setEmailRuleUpdateDataFail(response.response.data))
        }
    } catch (error) {
        yield put(addErrorAlert("Could not update EmailRule"))
        yield put(setEmailRuleUpdateDataFail(error))
    }
}

// delete
function* deleteEmailRuleDataService({ id }) {
  try {
    const response = yield call(ticketApi.delete, EMAILRULE_DELETE_API + id);
    if (response.status === 200) {
      yield put(addSuccessAlert(response.response.data.msg))
      yield put(setEmailRuleDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setEmailRuleDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error making EmailRule inactive"))
    yield put(setEmailRuleDeleteDataFail(error));
  }
}


export function* watchEmailRules(){
    yield takeLatest(EMAILRULE_TICKET_GET_DATA.EMAILRULE_TICKET_GET_DATA_LOAD, getEmailRuleTicketDataService);
    yield takeLatest(EMAIL_RULE_GET_DETAILS_DATA.EMAIL_RULE_GET_DETAILS_DATA_LOAD, getEmailRuleGetDataService);
    yield takeLatest(EMAILRULE_FORM_ADD_DATA.EMAILRULE_FORM_ADD_DATA_LOAD, postMyEmailRuleFormDataService);
    yield takeLatest(EMAILRULE_UPDATE_DATA.EMAILRULE_UPDATE_DATA_LOAD, postEmailRuleDataService);
    yield takeLatest(EMAILRULE_DELETE_DATA.EMAILRULE_DELETE_LOAD, deleteEmailRuleDataService);
}